import BaseComponent from "@js/components/base_component.jsx";
import classNames from "@js/helpers/class_names.js";

export class TabController extends BaseComponent {

  constructor(props) {
    super(props);

    this.state = {
      "selectedTab": 0,
    };
  }

  render() {
    return (
      <div className="tabs-container">
        <ul className="nav nav-tabs" role="tablist">
          { this._renderTabs() }
        </ul>
        <div className="tab-content">
          { this._renderTabContents() }
        </div>
        <br/>
      </div>
    );
  }

  _renderTabs() {
    let tabs = [];

    for ( let ii = 0; ii < this.props.children.length; ii++ ) {
      tabs.push(
        <li key={ ii } className={classNames({"active": ii==this.state.selectedTab})} key={ ii } onClick={(e) => this._selectTab(e, ii)}>
          <a className={""} data-toggle="tab">
            { this.props.children[ii].props.title }
          </a>
        </li>
      );
    }

    return tabs;
  }

  _renderTabContents() {
    let tabs = [];

    for ( let ii = 0; ii < this.props.children.length; ii++ ) {
      tabs.push(
        <div role="tabpanel" key={ ii } id={`tab-${ ii }`} className={classNames({"tab-pane": true, "active": ii==this.state.selectedTab})}>
          { this.props.children[ii] }
        </div>
      );
    }

    return tabs;
  }

  _selectTab(e, ii) {
    e.preventDefault()
    e.stopPropagation()

    this.setState({
      "selectedTab": ii,
    });
  }

}

export class TabPane extends BaseComponent {

  render() {
    return (
      <div className="panel-body">{ this.props.children }</div>
    );
  }

}
